<div class="body" [ngClass]="getBodyClass()" >
  <app-admin-header  (onToggleSideNav)="toggleCollapse($event)"></app-admin-header>
  <section class="content">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
